<template>
    <div class="mt-4 mb-4 mb-md-0">
        <b-form>           
            <b-form-textarea id="customMessage" variant="outline-black"
                    v-model="customText" 
                    v-on:update="updated" v-on:blur="blured"                  
                    :placeholder="getLanguageItem['ShopUi']['CustomMessageProductPlaceholder']"
                    :rows="5"
                    :max-rows="7">
            </b-form-textarea> 
        </b-form>
    </div>
</template>

<script>
export default {
    name: 'ShopVoucherCustomMessageForm',
    props:[
        'getSelectedItem'
    ],
    data(){return{
        lastChange: undefined,
        customText: '',
        timer: undefined,
    }},
    methods:{  
        blured (){
            /* not required anymore 
            if(this.customText == '' || this.customText == this.getSelectedItem.customText){
             console.log('Text not changed blur');             
             return;
            }
            console.log('Text Changed:', this.getSelectedItem.customText);    
            this.getSelectedItem.customText =  this.customText; */
        },
        updated(){
            //console.log('template: ',  this.getSelectedItem.selectedTemplate);            
           // console.log('updated: ', this.getSelectedItem.customText); 
            if(this.customText == this.getSelectedItem.customText){
                return;
            }

            this.debounce(1500); // fire update in n ms
        },
        debounce: function( delay) {
            var context = this;
            clearTimeout(this.timer);            
            this.timer = null;
            this.timer = setTimeout(function () {
                // console.log('updating delayed: ', context);
                
                context.getSelectedItem.customText = context.customText;
            
            }, delay);           
        }
    },
    computed:{
        getSelectedLanguage() {
            return this.$store.getters.getLanguage;
        },
        getLanguageItem() { 
          return this.$store.getters.getLanguageStrings;
        },
    },
}
</script>
